/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ProfileResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsProfile: build.query<ProfileResponse, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/profile` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsProfileApi };
export const { useGetSettingsProfileQuery, useLazyGetSettingsProfileQuery } = injectedRtkApi;
